export default __webpack_public_path__ + "static/media/clio_icon_device_monitoring.264aa5e1.svg";